@if (filterCount && filterCount > 0) {
    <vc-button
        iconName="filter_alt_off"
        mode="icon-tertiary"
        [matBadge]="filterCount"
        matBadgeOverlap="false"
        matBadgeSize="small"
        matBadgeColor="primary"
        [tooltip]="'COMMON_UI.TABLE.CLEAR_FILTERS' | transloco"
        (trigger)="clearFilters.emit()"></vc-button>
} @else {
    <vc-button
        iconName="filter_alt_off"
        mode="icon-tertiary"
        [tooltip]="'COMMON_UI.TABLE.CLEAR_FILTERS' | transloco"
        (trigger)="clearFilters.emit()"></vc-button>
}
